import type { PublicEvent } from './publicEvent'

export function groupSeries(events: PublicEvent[]) {
  const firsts = new Map<number, PublicEvent>()
  const laterDates = new Map<number, PublicEvent[]>()
  for (const event of events) {
    const first = firsts.get(event.series_id)
    if (first) laterDates.get(first.id)?.push(event)
    else {
      firsts.set(event.series_id, event)
      laterDates.set(event.id, [])
    }
  }
  return { events: [...firsts.values()], laterDates }
}
